import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { AudioOutputStream } from "../sdk/Audio/AudioOutputStream";
import { MessageDataStreamType } from "./ServiceMessages/ActivityResponsePayload";
export var DialogServiceTurnState = /*#__PURE__*/function () {
  function DialogServiceTurnState(manager, requestId) {
    _classCallCheck(this, DialogServiceTurnState);

    this.privRequestId = requestId;
    this.privIsCompleted = false;
    this.privAudioStream = null;
    this.privTurnManager = manager;
    this.resetTurnEndTimeout(); // tslint:disable-next-line:no-console
    // console.info("DialogServiceTurnState debugturn start:" + this.privRequestId);
  }

  _createClass(DialogServiceTurnState, [{
    key: "processActivityPayload",
    value: function processActivityPayload(payload) {
      if (payload.messageDataStreamType === MessageDataStreamType.TextToSpeechAudio) {
        this.privAudioStream = AudioOutputStream.createPullStream(); // tslint:disable-next-line:no-console
        // console.info("Audio start debugturn:" + this.privRequestId);
      }

      return this.privAudioStream;
    }
  }, {
    key: "endAudioStream",
    value: function endAudioStream() {
      if (this.privAudioStream !== null && !this.privAudioStream.isClosed) {
        this.privAudioStream.close();
      }
    }
  }, {
    key: "complete",
    value: function complete() {
      if (this.privTimeoutToken !== undefined) {
        clearTimeout(this.privTimeoutToken);
      }

      this.endAudioStream();
    }
  }, {
    key: "resetTurnEndTimeout",
    value: function resetTurnEndTimeout() {
      var _this = this;

      if (this.privTimeoutToken !== undefined) {
        clearTimeout(this.privTimeoutToken);
      } // tslint:disable-next-line:no-console
      // console.info("Timeout reset debugturn:" + this.privRequestId);


      this.privTimeoutToken = setTimeout(function () {
        // tslint:disable-next-line:no-console
        // console.info("Timeout complete debugturn:" + this.privRequestId);
        _this.privTurnManager.CompleteTurn(_this.privRequestId);

        return;
      }, 2000);
    }
  }, {
    key: "audioStream",
    get: function get() {
      // Called when is needed to stream.
      this.resetTurnEndTimeout();
      return this.privAudioStream;
    }
  }]);

  return DialogServiceTurnState;
}();